<template>
  <div>
    <a-collapse
      class="c-secondary-collapse"
      :bordered="false"
      expandIconPosition="right"
    >
      <a-collapse-panel header="Hasło" key="1">
        <form-wrapper
          ref="form"
          :service="Auth.changePassword"
          :formComponent="InnerForm"
          :form.sync="form"
          :errors.sync="errors"
          @formSubmitted="success"
        />
        <span slot="extra" type="setting">Zmień</span>
      </a-collapse-panel>
    </a-collapse>
  </div>
</template>

<script>
import InnerForm from './InnerForm'
import { Auth } from '@/api'

export default {
  data() {
    return {
      visible: false,
      objParams: null,
      form: {},
      errors: {},
      Auth,
      InnerForm
    }
  },
  methods: {
    onSubmit() {
      this.$refs.form.onSubmit()
    },
    openModal() {
      this.visible = true
    },
    success() {
      this.closeModal()
      this.$emit('formSubmitted')
    },
    closeModal() {
      this.resetForm()
      this.visible = false
    },
    resetForm() {
      this.form = {}
      this.errors = {}
    }
  }
}
</script>

<style lang="scss" scoped></style>
